<div class="modal-header" id="material-return-p58-modal-title">
    <h3 class="modal-title" id="modal-title" translate="MATERIAL_RETURN_TITLE"></h3>
    <span class="close" (click)="!isLoading && closeModal()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="materialReturnForm">
        <fieldset *ngIf="model.materialReturnList.length > 0">
            <div class="row mb-3">
                <label
                    class="col-md-2 col-12 col-form-label text-start"
                    translate="MATERIAL_RETURN_SEARCH_WITH_AWB_LABEL"
                ></label>
                <div class="col-md-10 col-12">
                    <pace-core-text-input
                        id="txtAwbReturn"
                        [(model)]="model.awbReturn"
                        [parentForm]="materialReturnChildren"
                        (valueChange)="selectMaterial()"
                        [ariaLabel]="'MATERIAL_RETURN_SEARCH_WITH_AWB_LABEL' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
        </fieldset>
        <div class="row">
            <div class="col-12 col-lg-6">
                <fieldset
                    class="mb-3 w-100"
                    [ngClass]="{
                        'col-md-5': displayAdditionalMaterialReturnInformation,
                        'col-md-4': !displayAdditionalMaterialReturnInformation,
                    }"
                >
                    <div class="container-fluid">
                        <div class="row p-2 border-bottom text-center table-header fw-bold">
                            <div
                                class="col-3 offset-2 d-flex gap-2 align-items-center"
                                (click)="setOrderBy('materialIdentifier.materialNumber.value')"
                            >
                                <ng-container *ngIf="!displayAdditionalMaterialReturnInformation">
                                    <span translate="MATERIAL_RETURN_MATERIAL_NUMBER_LABEL"></span>
                                    <span translate="MATERIAL_RETURN_DESCRIPTION_LABEL"></span>
                                </ng-container>
                                <ng-container *ngIf="displayAdditionalMaterialReturnInformation">
                                    <span class="fw-bold" translate="MATERIAL_RETURN_MATERIAL_COLUMN_LABEL"></span>
                                </ng-container>
                                <span
                                    class="sort-order"
                                    *ngIf="orderBy === 'materialIdentifier.materialNumber.value'"
                                    [ngClass]="{ reverse: reverse }"
                                ></span>
                            </div>
                            <div
                                class="col-4 d-flex gap-2 align-items-center"
                                *ngIf="displayAdditionalMaterialReturnInformation"
                                (click)="setOrderBy('notificationIdentifier.qmNum')"
                            >
                                <span class="fw-bold" translate="MATERIAL_RETURN_NOTIFICATION_COLUMN_LABEL"></span>
                                <span
                                    class="sort-order"
                                    *ngIf="orderBy === 'notificationIdentifier.qmNum'"
                                    [ngClass]="{ reverse: reverse }"
                                ></span>
                            </div>
                            <div class="col-3 d-flex gap-2 align-items-center" (click)="setOrderBy('quantity.value')">
                                <span class="fw-bold" translate="MATERIAL_RETURN_QUANTITY_LABEL"></span>
                                <span
                                    class="sort-order"
                                    *ngIf="orderBy === 'quantity.value'"
                                    [ngClass]="{ reverse: reverse }"
                                ></span>
                            </div>
                        </div>

                        <div
                            class="row p-2"
                            *ngFor="
                                let materialReturn of model.materialReturnList | orderBy: orderBy : reverse;
                                let last = last
                            "
                        >
                            <div class="col-2 p-0">
                                <pace-core-checkbox-input
                                    [parentForm]="materialReturnChildren"
                                    [(model)]="materialReturn.material.isRowSelected"
                                    (valueChange)="onMaterialSelectionChange(materialReturn)"
                                >
                                </pace-core-checkbox-input>
                            </div>
                            <div class="col-3 d-flex flex-column text-break">
                                {{ materialReturn.material.materialIdentifier.materialNumber.value }}
                                <ng-container
                                    *ngIf="
                                        displayAdditionalMaterialReturnInformation &&
                                        materialReturn.selectedPartSet.orderNumber.value
                                    "
                                >
                                    <br />({{ materialReturn.selectedPartSet.orderNumber.value }} |
                                    {{ materialReturn.selectedPartSet.orderPosition.value }})
                                </ng-container>
                                <ng-container *ngIf="materialReturn.material.description.value">
                                    <br />{{ materialReturn.material.description.value }}
                                </ng-container>
                                <ng-container
                                    *ngIf="
                                        displayAdditionalMaterialReturnInformation &&
                                        materialReturn.selectedPartSet.awb.value
                                    "
                                >
                                    <br />({{ materialReturn.selectedPartSet.awb.value }})
                                </ng-container>
                            </div>
                            <div
                                class="col-4 d-flex flex-column text-break"
                                *ngIf="displayAdditionalMaterialReturnInformation"
                            >
                                {{ materialReturn.material.notificationIdentifier.qmNum }}
                                <ng-container *ngIf="materialReturn.material.notificationIdentifier.maNum">
                                    <br />({{ materialReturn.material.notificationIdentifier.maNum }})
                                </ng-container>
                                <ng-container *ngIf="materialReturn.customerAddress.name1">
                                    <br />{{ materialReturn.customerAddress.name1.value }}
                                </ng-container>
                            </div>
                            <div class="col-3 d-flex flex-column text-break">
                                {{ materialReturn.material.quantity.value }}
                                <fa-icon
                                    [icon]="faUsers"
                                    class="ms-1"
                                    *ngIf="materialReturn.material.deliveryReturnSelectedOption === customerAddress"
                                ></fa-icon>
                                <fa-icon
                                    [icon]="faBuilding"
                                    class="ms-1"
                                    *ngIf="materialReturn.material.deliveryReturnSelectedOption === dopAddress"
                                ></fa-icon>
                                <fa-icon
                                    [icon]="faTaxi"
                                    class="ms-1"
                                    *ngIf="materialReturn.material.deliveryReturnSelectedOption === taxiAddress"
                                ></fa-icon>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
            <hr class="col-sm-6 d-sm-none d-none w-100 my-2" />

            <div class="col-12 col-lg-6">
                <div
                    [ngClass]="{
                        'col-md-12 col-12': displayAdditionalMaterialReturnInformation,
                        'col-md-8 col-12': !displayAdditionalMaterialReturnInformation,
                    }"
                >
                    <fieldset class="mb-3" [disabled]="model.isInfoSaved">
                        <div class="container-fluid">
                            <div *ngIf="model.materialReturnList.length > 0" class="material-details">
                                <pace-material-return-p58-detail
                                    [model]="model"
                                    [materialReturnChildren]="materialReturnChildren"
                                    (formValidated)="validateForm()"
                                    (addressOptionChanged)="onAddressOptionChanged()"
                                >
                                </pace-material-return-p58-detail>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <progressbar type="default" [value]="100" *ngIf="isLoading">
        {{ 'MATERIAL_RETURN_LOADING_MESSAGE' | translate }}
    </progressbar>
    <ng-container *ngIf="!isLoading">
        <div
            class="me-lg-auto flex-grow-1 flex-lg-grow-0 d-none d-lg-block"
            *ngIf="byBoxKonnectLink.length > 0"
            paceCoreLink
        >
            <a class="btn btn-primary pace-link w-100" href="{{ byBoxKonnectLink }}" target="_blank">ByBox Konnect</a>
        </div>
        <!-- Visible only on small screens -->
        <div class="me-lg-auto flex-grow-1 flex-lg-grow-0 d-lg-none" paceCoreLink>
            <button
                class="btn btn-primary w-100"
                type="button"
                [disabled]="!isMaterialPreparedForReturn() || !isMaterialReturnValid() || disableSendReturn"
                translate="MATERIAL_RETURN_SEND_RETURN_LABEL"
                (click)="sendReturn()"
            ></button>
        </div>

        <div class="d-lg-block d-none">
            <button
                class="btn btn-secondary mx-2"
                type="button"
                translate="MATERIAL_RETURN_RESET_DEFAULT"
                [disabled]="!isMaterialPreparedForReturn()"
                (click)="resetMaterialReturn()"
            ></button>
            <button
                class="btn btn-primary"
                type="button"
                translate="MATERIAL_RETURN_SAVE_LABEL"
                [disabled]="!isMaterialReturnValid()"
                (click)="saveMaterialReturn()"
            ></button>
            <button
                class="btn btn-primary mx-2"
                type="button"
                [disabled]="!isMaterialPreparedForReturn() || !isMaterialReturnValid() || disableSendReturn"
                translate="MATERIAL_RETURN_SEND_RETURN_LABEL"
                (click)="sendReturn()"
            ></button>
            <button
                class="btn btn-secondary"
                type="button"
                translate="MATERIAL_RETURN_CANCEL_LABEL"
                (click)="closeModal()"
            ></button>
        </div>

        <div class="btn-group d-lg-none menu-container" dropdown [dropup]="true">
            <button
                id="button-toggler"
                dropdownToggle
                type="button"
                class="btn btn-secondary more-toggler"
                aria-controls="dropdown-toggler"
                [attr.aria-label]="'MATERIAL_RETURN_ACTION_DROPDOWN_ARIA_LABEL' | translate"
            >
                <fa-icon [icon]="faEllipsisV"></fa-icon>
            </button>
            <ul
                id="dropdown-toggler"
                *dropdownMenu
                class="dropdown-menu dropdown-menu-right w-100"
                role="menu"
                aria-labelledby="button-toggler"
            >
                <!-- Small screen: Show ByBox Konnect in menu -->
                <li role="menuitem" *ngIf="byBoxKonnectLink.length > 0">
                    <a
                        class="btn btn-outline-secondary btn-lg w-100 text-primary link-primary text-decoration-underline"
                        href="{{ byBoxKonnectLink }}"
                        target="_blank"
                    >
                        ByBox Konnect
                    </a>
                </li>

                <li role="menuitem">
                    <button
                        class="btn btn-secondary btn-lg w-100"
                        type="button"
                        translate="MATERIAL_RETURN_RESET_DEFAULT"
                        [disabled]="!isMaterialPreparedForReturn()"
                        (click)="resetMaterialReturn()"
                    ></button>
                </li>

                <li role="menuitem">
                    <button
                        class="btn btn-secondary save-material btn-lg w-100"
                        type="button"
                        translate="MATERIAL_RETURN_SAVE_LABEL"
                        [disabled]="!isMaterialReturnValid()"
                        (click)="saveMaterialReturn()"
                    ></button>
                </li>

                <li role="menuitem">
                    <button
                        class="btn btn-secondary btn-lg w-100"
                        type="button"
                        translate="MATERIAL_RETURN_CANCEL_LABEL"
                        (click)="closeModal()"
                    ></button>
                </li>
            </ul>
        </div>
    </ng-container>
</div>
